export default "__VITE_ASSET__BT4VuhY2__"